(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studio-tulu-image-focus"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-focus-gallery')) {
  customElements.define('image-focus-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.track = this.querySelector('.ifg__track');
      this.cards = [...this.querySelectorAll('[data-card]:not([data-clone])')];
      if (!this.track || !this.cards.length) return;
      this.mobile = matchMedia('(max-width: 699px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.ratio = Number(this.dataset.ratio) || 1.5;
      this.style.setProperty('--ifg-ratio', this.ratio);
      this.active = Math.min(Number(this.dataset.initial)||0,this.cards.length-1);
      if (this.cards.length > 1) {
        const clone = (card) => {
          const el = card.cloneNode(true);
          el.dataset.clone = '';
          el.removeAttribute('data-block-id');
          el.removeAttribute('data-shopify-editor-block');
          el.setAttribute('aria-hidden','true');
          el.inert = true;
          el.removeAttribute('id');
          el.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
          el.querySelectorAll('[aria-controls]').forEach(node=>node.removeAttribute('aria-controls'));
          return el;
        };
        this.track.prepend(clone(this.cards.at(-1)));
        this.track.append(clone(this.cards[0]));
      }
      this.physical = [...this.track.querySelectorAll('[data-card]')];
      this.addEventListener('click', event => {
        const select = event.target.closest('[data-select]');
        const step = event.target.closest('[data-step]');
        if(select && this.contains(select)) this.select(Number(select.dataset.select),true);
        else if(step && this.contains(step)) this.select(this.active+Number(step.dataset.step),true);
      }, opts);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('[data-select],[data-step]')) return;
        if (event.key==='ArrowLeft' || event.key==='ArrowRight') {
          event.preventDefault(); this.select(this.active+(event.key==='ArrowRight'?1:-1),true);
        }
      },opts);
      this.track.addEventListener('scroll',()=>{
        if(!this.mobile.matches) return;
        clearTimeout(this.scrollTimer);
        this.scrollTimer=setTimeout(()=>this.settle(),120);
      },opts);
      this.onLayout = () => {
        this.measure();
        cancelAnimationFrame(this.layoutFrame);
        if(this.mobile.matches) this.layoutFrame=requestAnimationFrame(()=>this.center(this.cards[this.active],'auto'));
      };
      this.mobile.addEventListener('change',this.onLayout,opts);
      this.addEventListener('shopify:block:select',event=>{
        const index=this.cards.findIndex(card=>card.dataset.blockId===event.detail.blockId);
        if(index>=0) this.select(index,true);
      },opts);
      this.observer=new ResizeObserver(()=>this.onLayout());
      this.observer.observe(this.track);
      this.render(false); this.onLayout();
    }
    measure() {
      if(this.mobile.matches) return;
      const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;
      const width=this.track.clientWidth-gap*(this.cards.length-1);
      if(width<=0) return;
      const largeWidth=this.cards.length===1 ? width : width*2/(this.cards.length+1);
      this.style.setProperty('--ifg-image-height',(largeWidth/this.ratio)+'px');
    }
    select(index,scroll) {
      const next=(index+this.cards.length)%this.cards.length;
      const old=this.active; this.active=next; this.render(old!==next);
      if(this.mobile.matches && scroll) {
        let target=this.cards[next];
        if(this.cards.length>1 && old===this.cards.length-1 && index===old+1) target=this.physical.at(-1);
        if(this.cards.length>1 && old===0 && index===-1) target=this.physical[0];
        this.center(target,this.reduced.matches?'auto':'smooth');
      }
    }
    render(announce) {
      this.physical.forEach(card=>{
        const selected=Number(card.dataset.index)===this.active;
        card.classList.toggle('is-active',selected);
        card.querySelectorAll('[data-select]').forEach(button=>button.setAttribute('aria-pressed',String(selected)));
        card.querySelector('.ifg__description').hidden=!selected;
      });
      if(announce) this.querySelector('.ifg__status').textContent=this.cards[this.active].querySelector('[data-select]').getAttribute('aria-label')||this.cards[this.active].querySelector('.ifg__inline')?.textContent||'';
    }
    center(card,behavior) {
      const box=card.getBoundingClientRect(), track=this.track.getBoundingClientRect();
      this.track.scrollTo({left:this.track.scrollLeft+box.left-track.left-(track.width-box.width)/2,behavior});
    }
    settle() {
      if(!this.isConnected || !this.mobile.matches) return;
      const box=this.track.getBoundingClientRect();
      const midpoint=box.left+box.width/2;
      const nearest=this.physical.reduce((best,card)=>{
        const r=card.getBoundingClientRect();
        return Math.abs(r.left+r.width/2-midpoint)<Math.abs(best.getBoundingClientRect().left+best.getBoundingClientRect().width/2-midpoint)?card:best;
      });
      this.select(Number(nearest.dataset.index),false);
      if(nearest.hasAttribute('data-clone')) this.center(this.cards[this.active],'auto');
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      clearTimeout(this.scrollTimer); cancelAnimationFrame(this.layoutFrame);
      this.querySelectorAll('[data-clone]').forEach(card=>card.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-tulu-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
/* Instance lifecycle for the theme editor. */
if (!customElements.get('studio-tulu-image-overlay')) {
  customElements.define('studio-tulu-image-overlay', class extends HTMLElement {
    connectedCallback() {
      this.claims = [...this.querySelectorAll('[data-claim]')];
      this.pauseButton = this.querySelector('.st-hero__pause');
      this.content = this.querySelector('.st-hero__content');
      this.bar = this.querySelector('.st-hero__bar');
      this.mobile = matchMedia('(max-width: 699px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.scheduleMeasure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.refresh = () => { this.renderClaims(); this.restart(); this.scheduleMeasure(); };
      this.mobile.addEventListener('change', this.refresh, options);
      this.reduced.addEventListener('change', this.refresh, options);
      window.addEventListener('resize', this.scheduleMeasure, options);
      document.addEventListener('visibilitychange', () => this.restart(), options);
      this.addEventListener('mouseenter', () => { this.hovering = matchMedia('(hover: hover)').matches; this.restart(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.restart(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.restart(); }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (this.isConnected) { this.focused = this.contains(document.activeElement); this.restart(); } });
      }, options);
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
        this.restart();
      }, options);
      this.setAttribute('data-ready', '');
      this.observer = new ResizeObserver(this.scheduleMeasure);
      [this.content, this.bar, ...document.querySelectorAll('.shopify-section-group-header-group')].filter(Boolean).forEach(el => this.observer.observe(el));
      document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleMeasure(); });
      this.refresh();
    }
    measure() {
      if (!this.isConnected) return;
      if (this.dataset.heightMode === 'custom') {
        this.style.removeProperty('--st-measured-height');
        this.lastHeight = null;
        return;
      }
      // Stable mobile viewport avoids jumping when the browser toolbar moves.
      const viewportProbe = document.createElement('div');
      viewportProbe.style.cssText = 'position:fixed;height:100svh;visibility:hidden;pointer-events:none;';
      this.append(viewportProbe);
      const viewport = viewportProbe.getBoundingClientRect().height || window.innerHeight;
      viewportProbe.remove();
      // Keep later instances at the same viewport height as the first hero.
      const top = this.getBoundingClientRect().top + window.scrollY;
      const headerHeight = [...document.querySelectorAll('.shopify-section-group-header-group')]
        .reduce((total, el) => total + el.getBoundingClientRect().height, 0);
      const available = viewport - Math.max(0, Math.min(top, headerHeight));
      const minimum = (this.content?.scrollHeight || 0) + (this.bar?.offsetHeight || 0);
      const height = Math.ceil(Math.max(available, minimum, 320));
      if (height !== this.lastHeight) { this.style.setProperty('--st-measured-height', height + 'px'); this.lastHeight = height; }
    }
    renderClaims() {
      this.toggleAttribute('data-static', this.reduced.matches);
      this.claims.forEach((claim, i) => {
        const active = !this.mobile.matches || this.reduced.matches || i === this.index;
        claim.classList.toggle('is-active', i === this.index);
        claim.setAttribute('aria-hidden', String(!active));
      });
      if (this.pauseButton) this.pauseButton.hidden = true;
    }
    restart() {
      clearInterval(this.timer);
      if (!this.mobile.matches || this.reduced.matches || this.paused || this.focused || this.hovering || document.hidden || this.claims.length < 2) return;
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.claims.length;
        this.renderClaims();
      }, Number(this.dataset.interval) || 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-tulu-media-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('studio-tulu-media-hero')) {
  customElements.define('studio-tulu-media-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.normalizeLogo();
      this.scheduleMeasure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      window.addEventListener('resize', this.scheduleMeasure, options);
      this.observer = new ResizeObserver(this.scheduleMeasure);
      document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => this.observer.observe(el));
      this.scheduleMeasure();
    }
    normalizeLogo() {
      this.querySelectorAll('.sth__logo svg').forEach((svg) => {
        const viewBox = svg.getAttribute('viewBox') || svg.getAttribute('viewbox');
        if (!viewBox) {
          const w = parseFloat(svg.getAttribute('width'));
          const h = parseFloat(svg.getAttribute('height'));
          if (w && h) svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
        } else if (!svg.getAttribute('viewBox')) {
          svg.setAttribute('viewBox', viewBox);
          svg.removeAttribute('viewbox');
        }
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.style.setProperty('width', '100%', 'important');
        svg.style.setProperty('height', 'auto', 'important');
      });
    }
    measure() {
      if (!this.isConnected) return;
      if (this.dataset.heightMode === 'custom') {
        this.style.removeProperty('--sth-measured-height');
        this.lastHeight = null;
        return;
      }
      const probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;height:100svh;visibility:hidden;pointer-events:none;';
      this.append(probe);
      const viewport = probe.getBoundingClientRect().height || window.innerHeight;
      probe.remove();
      const top = this.getBoundingClientRect().top + window.scrollY;
      const headerHeight = [...document.querySelectorAll('.shopify-section-group-header-group')]
        .reduce((total, el) => total + el.getBoundingClientRect().height, 0);
      const available = viewport - Math.max(0, Math.min(top, headerHeight));
      const height = Math.ceil(Math.max(available, 480));
      if (height !== this.lastHeight) {
        this.style.setProperty('--sth-measured-height', height + 'px');
        this.lastHeight = height;
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-tulu-mood-collections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mood-collections')) {
  customElements.define('mood-collections', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.index = 0;
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) this.select(Number(tab.dataset.tab));
      }, opts);
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-tab]');
        if (!tab) return;
        const tabs = this.getTabs();
        let next = Number(tab.dataset.tab);
        if (event.key === 'ArrowRight') next++;
        else if (event.key === 'ArrowLeft') next--;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(next);
        this.getTabs()[this.index]?.focus();
      }, opts);
      this.addEventListener('shopify:block:select', (event) => {
        const blockId = String(event.detail?.blockId || '');
        const index = this.getPanels().findIndex((panel) => panel.dataset.blockId === blockId);
        if (index >= 0) this.select(index);
      }, opts);
      document.addEventListener('shopify:section:load', (event) => {
        if (!event.target?.contains?.(this) && event.target !== this) return;
        this.refreshObserver();
        this.select(this.index);
      }, opts);
      this.observer = new ResizeObserver(() => this.measure());
      this.refreshObserver();
      this.addEventListener('load', () => this.measure(), { ...opts, capture: true });
      this.select(0);
    }
    getTabs() {
      return [...this.querySelectorAll('[data-tab]')];
    }
    getPanels() {
      return [...this.querySelectorAll('[data-panel]')];
    }
    refreshObserver() {
      this.observer?.disconnect();
      this.getPanels().forEach((panel) => {
        const products = panel.querySelector('[data-products]');
        if (products) this.observer.observe(products);
        const img = products?.querySelector('img');
        if (img) this.observer.observe(img);
      });
    }
    select(index) {
      const panels = this.getPanels();
      const tabs = this.getTabs();
      if (!panels.length) return;
      this.index = ((index % panels.length) + panels.length) % panels.length;
      tabs.forEach((tab, i) => {
        const selected = i === this.index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        panel.hidden = i !== this.index;
      });
      this.refreshObserver();
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.measure();
        window.dispatchEvent(new Event('resize'));
      });
    }
    measure() {
      const panel = this.getPanels()[this.index];
      if (!panel || panel.hidden) return;
      const flush = panel.dataset.moodFlush === 'true';
      const products = panel.querySelector('[data-products]');
      if (!products) return;
      let height = 0;
      if (flush) {
        const list = products.querySelector('.mcc__product-carousel, .mcc__product-grid, product-list, .product-list');
        const cards = [...products.querySelectorAll('product-card, .product-card')];
        if (cards.length) {
          const top = products.getBoundingClientRect().top;
          height = Math.max(...cards.map((card) => card.getBoundingClientRect().bottom)) - top;
        } else {
          height = list?.getBoundingClientRect().height || 0;
        }
        // Image + View-all link share the product-card height; shrink image for the link.
        const moodLink = panel.querySelector('.mcc__mood-link');
        if (moodLink && getComputedStyle(moodLink).display !== 'none') {
          height -= moodLink.getBoundingClientRect().height;
        }
      } else {
        height = products.querySelector('img')?.getBoundingClientRect().height || 0;
      }
      if (height > 0) panel.style.setProperty('--mcc-mood-height', Math.round(height) + 'px');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-tulu-product-hotspots"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('product-hotspot-looks')) {
  customElements.define('product-hotspot-looks',class extends HTMLElement {
    connectedCallback() {
      this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.hover=matchMedia('(hover: hover) and (pointer: fine)');
      this.addEventListener('pointerover',event=>{
        const dot=event.target.closest('[data-hotspot]');
        if(dot && this.hover.matches && event.pointerType!=='touch')this.open(dot);
      },opts);
      this.addEventListener('click',event=>{
        const dot=event.target.closest('[data-hotspot]');
        if(dot){this.active===dot?this.close():this.open(dot)}
      },opts);
      this.querySelectorAll('[data-look]').forEach(look=>look.addEventListener('pointerleave',()=>{
        if(this.hover.matches && !look.contains(document.activeElement))this.close();
      },opts));
      this.addEventListener('focusout',()=>{
        requestAnimationFrame(()=>{if(this.isConnected && !this.contains(document.activeElement))this.close()});
      },opts);
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target) || !event.target.closest('[data-hotspot],[data-popup]'))this.close()},opts);
      this.addEventListener('keydown',event=>{
        if(event.key==='Escape' && this.active){const dot=this.active;this.close();dot.focus()}
      },opts);
      // CUSTOM: a color tile inside a popup moves link and price to the chosen variant (same template contract as custom.js on cards)
      this.addEventListener('change',event=>{
        const radio=event.target;
        if(!(radio instanceof HTMLInputElement) || radio.type!=='radio' || !radio.hasAttribute('data-variant-id'))return;
        const popup=radio.closest('[data-popup]');if(!popup)return;
        const url=radio.getAttribute('data-product-url');
        if(url)popup.querySelectorAll('[data-custom-product-link]').forEach(link=>{link.href=url});
        const state=popup.querySelector('template[data-custom-card-state="'+radio.getAttribute('data-variant-id')+'"]');
        const price=state?.content.querySelector('[data-custom-state-price]');
        const host=popup.querySelector('[data-custom-card-price]');
        if(host && price)host.innerHTML=price.innerHTML;
        this.position();
      },opts);
      window.addEventListener('resize',()=>this.position(),opts);
      this.addEventListener('shopify:block:select',event=>{
        const look=[...this.querySelectorAll('[data-look]')].find(el=>el.dataset.blockId===event.detail.blockId);
        const dot=look?.querySelector('[data-hotspot]');if(dot)this.open(dot);
      },opts);
    }
    open(dot) {
      if(this.active===dot)return;
      this.close();this.active=dot;
      this.popup=this.querySelector('[id="'+dot.getAttribute('aria-controls')+'"]');
      if(!this.popup){this.active=null;return}
      this.popup.hidden=false;dot.setAttribute('aria-expanded','true');this.position();
    }
    close() {
      if(this.active)this.active.setAttribute('aria-expanded','false');
      if(this.popup)this.popup.hidden=true;
      this.active=null;this.popup=null;
    }
    position() {
      if(!this.active || !this.popup)return;
      const media=this.active.closest('.phl__media');const box=media.getBoundingClientRect();
      if(!box.width || !box.height){this.close();return}
      const dot=this.active.getBoundingClientRect();const width=this.popup.offsetWidth,height=this.popup.offsetHeight;
      const x=dot.left+dot.width/2-box.left,y=dot.top+dot.height/2-box.top;
      let left=x+24;if(left+width>box.width-16)left=x-width-24;
      let top=y+24;if(top+height>box.height-16)top=y-height-24;
      left=Math.max(16,Math.min(left,box.width-width-16));
      top=Math.max(16,Math.min(top,box.height-height-16));
      this.popup.style.left=left+'px';this.popup.style.top=top+'px';
    }
    disconnectedCallback(){this.abort?.abort();this.close()}
  });
}

  } catch(e) { console.error(e); }
})();
})();
